import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spin, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import publicCourseService from "../../services/publicCourseService";
import CourseOverview from "../user/CourseOverview";
import API_BASE from "../../config/apiConfig";

const API_BASE_URL = `${API_BASE}/images/proxy`;

const CoursePreviewPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [imageUrl, setImageUrl] = useState("/default-image.png");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        setLoading(true);
        const data = await publicCourseService.getCourseById(id);
        setCourse(data);
        if (data?.image) {
          setImageUrl(`${API_BASE_URL}?url=${encodeURIComponent(data.image)}`);
        }
      } catch (err) {
        console.error("Erreur chargement cours:", err);
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchCourse();
  }, [id]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <Spin size="large" tip="Chargement du cours..." />
      </div>
    );
  }

  if (!course) {
    return (
      <div style={{ textAlign: "center", padding: 60 }}>
        <p>Cours introuvable.</p>
        <Button onClick={() => navigate("/courses")}>Retour aux cours</Button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", padding: "20px 16px" }}>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: 16, borderRadius: 8 }}
      >
        Retour
      </Button>
      <CourseOverview
        course={course}
        imageUrl={imageUrl}
        onStartLearning={() => navigate(`/learning/course/${id}`)}
      />
    </div>
  );
};

export default CoursePreviewPage;